import { pushSnowplow, toTeamsFeatureSchema } from '../snowplow'
import { ACTION_TARGETS, ACTION_TARGET_TYPES, ACTION_TYPES, VIEWS, VIEW_TYPES } from './teamsEvents'

// ------------------------------------
// Manage Team Members Events
// ------------------------------------
export const publishViewedManageMembersPage = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.MANAGE_MEMBERS, VIEW_TYPES.PAGE, ACTION_TYPES.VIEWED))

export const publishChangedMemberSearch = input =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MEMBERS,
      VIEW_TYPES.TABLE,
      ACTION_TYPES.CHANGED,
      ACTION_TARGETS.SEARCH_MEMBERS,
      ACTION_TARGET_TYPES.INPUT,
      input,
    ),
  )

export const publishClickedSortMembers = searchParam =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MEMBERS,
      VIEW_TYPES.TABLE,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.SORT_MEMBERS,
      ACTION_TARGET_TYPES.BUTTON,
      searchParam,
    ),
  )

export const publishRemoveMembers = memberIds =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MEMBERS,
      VIEW_TYPES.TABLE,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.REMOVE_MEMBER,
      ACTION_TARGET_TYPES.BUTTON,
      memberIds,
    ),
  )

export const publishClickedCloseConfirmRemoveMembers = memberIds =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.CONFIRM_REMOVE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.CLOSE,
      ACTION_TARGET_TYPES.BUTTON,
      memberIds,
    ),
  )

export const publishClickedConfirmRemoveMembers = (memberIds, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.CONFIRM_REMOVE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.CONFIRM_REMOVE,
      ACTION_TARGET_TYPES.BUTTON,
      memberIds,
      error,
    ),
  )

export const publishClickedInviteMembers = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MANAGE_MEMBERS,
      VIEW_TYPES.PAGE,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.INVITE_MEMBERS,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishViewedInviteMemberByLink = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.INVITE_BY_LINK, VIEW_TYPES.DIALOG, ACTION_TYPES.VIEWED))

export const publishClickedCopyInviteLink = inviteLink =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.INVITE_BY_LINK,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.COPY_INVITE_LINK,
      ACTION_TARGET_TYPES.BUTTON,
      inviteLink,
    ),
  )

export const publishViewedInviteMemberByEmail = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.INVITE_BY_EMAIL, VIEW_TYPES.DIALOG, ACTION_TYPES.VIEWED))

export const publishChangedMemberEmails = (memberEmails, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.INVITE_BY_EMAIL,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CHANGED,
      ACTION_TARGETS.INVITE_EMAIL_ADDRESSES,
      ACTION_TARGET_TYPES.INPUT,
      memberEmails,
      error,
    ),
  )

export const publishClickedSendInvites = (input, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.INVITE_BY_EMAIL,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.SEND_INVITES,
      ACTION_TARGET_TYPES.BUTTON,
      input,
      error,
    ),
  )

// ------------------------------------
// Manage Team Account Events
// ------------------------------------
export const publishViewedManageAccountPage = () =>
  pushSnowplow(toTeamsFeatureSchema(VIEWS.MANAGE_ACCOUNT, VIEW_TYPES.PAGE, ACTION_TYPES.VIEWED))

export const publishClickedEditTeamInfo = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MANAGE_TEAM_INFO,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.EDIT,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishClickedCancelEditTeamInfo = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MANAGE_TEAM_INFO,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.CANCEL,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

export const publishChangeJoinability = input =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MANAGE_SETTINGS,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CHANGED,
      ACTION_TARGETS.JOINABILITY_SETTING,
      ACTION_TARGET_TYPES.RADIO,
      input,
    ),
  )

export const publishClickedSubmitSettings = error =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MANAGE_SETTINGS,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.SUBMIT,
      ACTION_TARGET_TYPES.BUTTON,
      undefined,
      error,
    ),
  )

export const publishClickedCancelJoinability = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MANAGE_SETTINGS,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.CANCEL,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

// TODO Use this when we have the edit payment functionality
export const publishClickedEditPayment = () =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MANAGE_PAYMENT,
      VIEW_TYPES.COMPONENT,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.EDIT,
      ACTION_TARGET_TYPES.BUTTON,
    ),
  )

// ------------------------------------
// Accept/Decline Invite Events
// ------------------------------------
export const publishViewedInviteDialog = (teamInviteCode, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.ACCEPT_DECLINE_INVITE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.VIEWED,
      undefined,
      undefined,
      teamInviteCode,
      error,
    ),
  )

export const publishClickedAcceptInvite = (accountId, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.ACCEPT_DECLINE_INVITE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.ACCEPT_INVITE,
      ACTION_TARGET_TYPES.BUTTON,
      accountId,
      error,
    ),
  )

export const publishClickedDeclineInvite = (accountId, error) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.ACCEPT_DECLINE_INVITE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.DECLINE_INVITE,
      ACTION_TARGET_TYPES.BUTTON,
      accountId,
      error,
    ),
  )
